// 直接减
export const PREFERENTIAL_MODE_DECREASE = "DECREASE";
// 打折
export const PREFERENTIAL_MODE_DISCOUNT = "DISCOUNT";

export const COUPON_STATUS = {
  USED: "USED", // 已使用
  FROZEN: "FROZEN", //冻结
  GOT: "GOT", // 持有
  EXPIRED: "EXPIRED", // 过期
};
